module.exports = __webpack_public_path__ + "static/desc.1921c982.png";